import { ROLES } from "./roles";

// Lazy imports (same pattern as App.js)
import Dashboard from "../pages/dashboard/Dashboard";
import InstantRequest from "../pages/seller/InstantRequest";
import MyOffers from "../pages/seller/MyOffers";
import OfferDetails from "../pages/seller/OfferDetails";
import RequestDetails from "../pages/buyer/RequestDetails";
import Orders from "../pages/seller/Orders";
import AdminFreight from "../pages/admin/AdminFreight";
import FreightNewUser from "../pages/admin/FreightNewUser";
import FreightActiveUsersPage from "../pages/admin/freight/FreightActiveUsersPage";
import FreightInactiveUsersPage from "../pages/admin/freight/FreightInactiveUsersPage";
import FreightUserFormPage from "../pages/admin/freight/FreightUserFormPage";
import FreightProfilingPage from "../pages/admin/freight/FreightProfilingPage";
import FreightRmMapPage from "../pages/admin/freight/FreightRmMapPage";
import FreightOrdersPage from "../pages/admin/freight/FreightOrdersPage";
import FreightOrderViewPage from "../pages/admin/freight/FreightOrderViewPage";
import FreightOrderFormPage from "../pages/admin/freight/FreightOrderFormPage";
import FreightRmChatsPage from "../pages/admin/freight/FreightRmChatsPage";
import FreightFormRequestsPage from "../pages/admin/freight/FreightFormRequestsPage";
import FreightFaqsPage from "../pages/admin/freight/FreightFaqsPage";
import FreightFaqFormPage from "../pages/admin/freight/FreightFaqFormPage";
import FreightFaqSectionsPage from "../pages/admin/freight/FreightFaqSectionsPage";
import FreightFaqSectionFormPage from "../pages/admin/freight/FreightFaqSectionFormPage";
import FreightAccountUnderReviewSliderPage from "../pages/admin/freight/FreightAccountUnderReviewSliderPage";
import FreightProfileStatusPage from "../pages/admin/freight/FreightProfileStatusPage";
import FreightProfileStatusFormPage from "../pages/admin/freight/FreightProfileStatusFormPage";
import FreightOrderStatusPage from "../pages/admin/freight/FreightOrderStatusPage";
import FreightOrderStatusFormPage from "../pages/admin/freight/FreightOrderStatusFormPage";
import FreightSocialMediaPage from "../pages/admin/freight/FreightSocialMediaPage";
import FreightSocialMediaFormPage from "../pages/admin/freight/FreightSocialMediaFormPage";
import FreightAppDrawerPage from "../pages/admin/freight/FreightAppDrawerPage";
import FreightVehicleCapacitiesPage from "../pages/admin/freight/FreightVehicleCapacitiesPage";
import FreightVehicleCapacitiesFormPage from "../pages/admin/freight/FreightVehicleCapacitiesFormPage";
import FreightServiceCategoriesPage from "../pages/admin/freight/FreightServiceCategoriesPage";
import FreightServiceCategoriesFormPage from "../pages/admin/freight/FreightServiceCategoriesFormPage";

export const routesByRole = {

    [ROLES.SELLER]: [
        { path: "/dashboard", component: Dashboard },
        { path: "/instant-request", component: InstantRequest },
        { path: "/my-offers", component: MyOffers },
        { path: "/offer/:offerId", component: OfferDetails },
        { path: "/orders", component: Orders }
    ],

    [ROLES.BUYER]: [
        { path: "/dashboard", component: Dashboard },
        { path: "/request/:id", component: RequestDetails }
    ],

    [ROLES.FREIGHT]: [
        { path: "/dashboard", component: Dashboard }
    ],

    [ROLES.ADMIN]: [
        { path: "/dashboard", component: Dashboard },
        { path: "/freight/users/new", component: FreightUserFormPage },
        { path: "/freight/active_users/:id/profiling", component: FreightProfilingPage },
        { path: "/freight/active_users/:id/rm", component: FreightRmMapPage },
        { path: "/freight/new_users/:id/rm", component: FreightRmMapPage },
        { path: "/freight/active_users/:id/edit", component: FreightUserFormPage },
        { path: "/freight/new_users/:id/edit", component: FreightUserFormPage },
        { path: "/freight/active_users", component: FreightActiveUsersPage },
        { path: "/freight/inactive_users", component: FreightInactiveUsersPage },
        { path: "/freight/new_users", component: FreightNewUser },
        { path: "/freight/orders/new", component: FreightOrderFormPage },
        { path: "/freight/orders/:id/edit", component: FreightOrderFormPage },
        { path: "/freight/orders/:id", component: FreightOrderViewPage },
        { path: "/freight/orders", component: FreightOrdersPage },
        { path: "/freight/rm_chats", component: FreightRmChatsPage },
        { path: "/freight/form_request", component: FreightFormRequestsPage },
        { path: "/freight/faq_section/new", component: FreightFaqSectionFormPage },
        { path: "/freight/faq_section/:id/edit", component: FreightFaqSectionFormPage },
        { path: "/freight/faq_section", component: FreightFaqSectionsPage },
        { path: "/freight/faqs/new", component: FreightFaqFormPage },
        { path: "/freight/faqs/:id/edit", component: FreightFaqFormPage },
        { path: "/freight/faqs", component: FreightFaqsPage },
        { path: "/freight/account_under_review", component: FreightAccountUnderReviewSliderPage },
        { path: "/freight/profile_status/new", component: FreightProfileStatusFormPage },
        { path: "/freight/profile_status/:id/edit", component: FreightProfileStatusFormPage },
        { path: "/freight/profile_status", component: FreightProfileStatusPage },
        { path: "/freight/order_status/new", component: FreightOrderStatusFormPage },
        { path: "/freight/order_status/:id/edit", component: FreightOrderStatusFormPage },
        { path: "/freight/order_status", component: FreightOrderStatusPage },
        { path: "/freight/social_media/new", component: FreightSocialMediaFormPage },
        { path: "/freight/social_media/:id/edit", component: FreightSocialMediaFormPage },
        { path: "/freight/social_media", component: FreightSocialMediaPage },
        { path: "/freight/vehicle_capacities/new", component: FreightVehicleCapacitiesFormPage },
        { path: "/freight/vehicle_capacities/:id/edit", component: FreightVehicleCapacitiesFormPage },
        { path: "/freight/vehicle_capacities", component: FreightVehicleCapacitiesPage },
        { path: "/freight/service_categories/new", component: FreightServiceCategoriesFormPage },
        { path: "/freight/service_categories/:id/edit", component: FreightServiceCategoriesFormPage },
        { path: "/freight/service_categories", component: FreightServiceCategoriesPage },
        { path: "/freight/app_drawer", component: FreightAppDrawerPage },
        { path: "/freight", component: AdminFreight }
    ]

};